<template>
  <v-card
      v-if="loading_get_tech_map || check_type_course"
      class="rounded-xl"
      min-width="100%"
      height="300px"
      elevation="0"
      tile
  >
    <v-layout class="justify-center align-center fill-height">
      <v-progress-circular :size="120" :width="6" indeterminate color="teal"></v-progress-circular>
    </v-layout>
    <v-dialog
        content-class="rounded-xl"
        v-model="check_type_course"
        width="600px"
        persistent
    >
      <v-card outlined class="rounded-xl">
        <v-card-title>
          <h6 class="text-sm-h4 text-h6 mx-auto">
            Укажите тип курса
          </h6>
        </v-card-title>
        <v-card-text>
          <v-row justify="center">
            <v-col cols="6">
              <v-card
                  @click="choiceTypeCourse(1)"
                  class="rounded-xl d-flex justify-center align-center"
                  outlined
                  height="50px"
              >
                <div class="subtitle-1 text-center">Стандартный курс</div>
              </v-card>
            </v-col>
            <v-col cols="6">
              <v-card
                  @click="choiceTypeCourse(2)"
                  class="rounded-xl d-flex justify-center align-center"
                  outlined
                  height="50px"
              >
                <div class="subtitle-1 text-center">Элективная дисциплина свободного выбора</div>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-card>
  <v-card v-else elevation="0" min-width="100%" class="d-flex justify-center">
    <v-card
        class="rounded-xl"
        outlined
        min-width="100%"
        tile
    >
      <div v-if="tm_download" class="d-flex justify-start position-relative">
        <h6 class="text-subtitle-1 edit-mode-text-l teal--text">
          Скачать ТК
        </h6>
        <v-btn
            @click="createFileTM"
            elevation="0"
            class="edit-btn-l ma-2"
            small
            fab
            outlined
            color="teal"
        >
          <v-icon size="15px">
            fa-download
          </v-icon>
        </v-btn>
      </div>
      <div v-if="Object.keys(technical_map).length > 0" class="d-flex justify-end position-relative">
        <v-slide-x-transition>
          <h6 v-if="edit_mode" class="text-subtitle-1 edit-mode-text orange--text">
            Режим редактирования
          </h6>
        </v-slide-x-transition>
        <v-btn
            v-if="technical_map.status === 'edit'"
            @click="edit_mode = !edit_mode"
            elevation="0"
            class="edit-btn ma-2"
            small
            fab
            :dark="edit_mode"
            :outlined="!edit_mode"
            color="warning"
        >
          <v-icon size="15px">
            fa-edit
          </v-icon>
        </v-btn>
      </div>
      <v-card-title>
        <h6
            class="mx-auto text-caption text-uppercase text--secondary"
        >
          Технологическая карта
        </h6>
      </v-card-title>
      <v-card-text>
        <CardParticipants
            :edit_mode="edit_mode"
            :cofounders="data_addit.cofounders"
            :full_name_author="full_name_author"
            @inputCofounder="inputCofounder($event)"
            @addVoidCofounder="addVoidCofounder"
            @deleteNameCofounder="deleteNameCofounder($event)"
        />
        <CardAdditData
            v-if="data_addit.type_course === 1 || data_addit.type_course === 'Стандарт'"
            :data_addit="data_addit"
            :edit_mode="edit_mode"
            @setEducationalProgramsIds="setEducationalProgramsIds"
            @setCurriculumId="setCurriculumId"
            @setChairIds="setChairIds"
            @setStudyYearId="setStudyYearId"
            @setDisciplineId="setDisciplineId"
            @setSemesters="setSemesters"
            @setFormEducation="setFormEducation"
        />
        <CardAdditDataForElective
            v-else
            :data_addit="data_addit"
            :edit_mode="edit_mode"
            @setLevelEducation="setLevelEducation"
            @setChairIds="setChairIds"
            @setStudyYearId="setStudyYearId"
            @setDisciplineId="setDisciplineId"
            @setSemesters="setSemesters"
            @setFormEducation="setFormEducation"
        />
        <div class="mt-6" v-if="visible_tech_map">
          <h6
              v-if="Object.keys(current_course).length > 0"
              class="text-sm-h5 text-h6 text-center"
          >
            <a class="teal--text" :href='`https://newmoodle.amursu.ru/course/view.php?id=${current_course.course_id}`'
               target="_blank">
              {{ current_course.course_full_name }}
            </a>
          </h6>
          <h6
              v-else
              class="text-sm-h5 text-h5 text-center"
          >
            <a class="teal--text" :href='`https://newmoodle.amursu.ru/course/view.php?id=${technical_map.course_id}`'
               target="_blank">
              {{ technical_map.course_full_name }}
            </a>
          </h6>
        </div>
        <div
            class="text-center"
        >
          <div v-for="(semester, index_semester) in list_curriculum_lines" :key="index_semester">
            <v-row align="center" justify="center">
              <v-col cols="5">
                <v-divider></v-divider>
              </v-col>
              <v-col cols="2" class="text-center">
                <div class="my-4 text-h5">
                  {{ semester.semester_name }}
                </div>
              </v-col>
              <v-col cols="5">
                <v-divider></v-divider>
              </v-col>
            </v-row>
            <v-row class="mt-4" justify="center">
              <v-col v-for="(form_control, index_format_control) in semester.format_controls" cols="4" :key="index_format_control">
                <v-autocomplete
                    :value="form_control"
                    :items="areas_training"
                    :readonly="!edit_mode"
                    :clearable="edit_mode"
                    @input="setFormatControlForSemester($event, index_semester, semester, index_format_control)"
                    :rules="[v => !!v || 'Обязательное поле не заполнено']"
                    no-data-text="Данные отсутствуют"
                    label="Форма контроля"
                    dense
                    hide-details
                    rounded
                    outlined
                >
                  <template v-if="index_format_control !== 0 && edit_mode" v-slot:append-outer>
                    <div class="d-flex align-center justify-center">
                      <v-btn
                          @click="deleteFormControl(semester, index_format_control)"
                          x-small
                          fab
                          outlined
                          color="error"
                      >
                        <v-icon size="15px" dark>
                          fa-trash
                        </v-icon>
                      </v-btn>
                    </div>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <div class="d-flex align-center justify-center my-2">
              <v-btn
                  v-if="edit_mode"
                  @click="addFormControl(semester)"
                  elevation="0"
                  small
                  outlined
                  fab
                  color="teal"
              >
                <v-icon size="15px">
                  fa-plus
                </v-icon>
              </v-btn>
            </div>
            <v-btn
                v-if="(data_addit.type_course === 2 || data_addit.type_course === 'Электив') && edit_mode"
                @click="openDialogEditEduHours(semester.hours)"
                elevation="0"
                small
                outlined
                fab
                color="teal"
            >
              <v-icon size="15px">
                fa-edit
              </v-icon>
            </v-btn>
            <v-chip
                class="ma-1 pr-0"
                outlined
                large
                v-for="hour in semester.hours"
                :key="hour.id"
            >
              {{ hour.load }}
              <div
                  class="rounded-pill teal pa-4 ml-2"
              >
                <span class="text-h6 white--text">{{ hour.value }} </span>
                <span class="white--text"> акад. час.</span>
              </div>

            </v-chip>
            <div class="mt-3" v-if="data_table[index_semester]" :key="componentKey">
              <CardTableTechMap
                  :data_table="data_table[index_semester].data_tech_map"
                  :semester="data_table[index_semester].semester"
                  :format_controls="data_table[index_semester].format_controls"
                  :edit_mode="edit_mode"
                  :alternative_view="alternative_view"
                  :areas_training="areas_training"
                  @asyncCurrentTechMap="asyncCurrentTechMap"
              />
            </div>
          </div>
          <DialogEditEduHours
              :dialog_vis_edit_hours="dialog_vis_edit_hours"
              :semester_hours="edit_semester_hours"
              @closeDialogEditEduHours="closeDialogEditEduHours"
              @setHoursInTypeWork="setHoursInTypeWork($event, edit_semester_hours)"
          />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn
            v-if="visible_sending_tech_map"
            @click="sendingTechMap(data_table, data_addit)"
            class="rounded-xl"
            color="teal"
            dark
        >
          Отправить на проверку
        </v-btn>
        <v-slide-x-transition>
          <v-btn
              v-if="Object.keys(technical_map).length > 0 && edit_mode"
              @click="updatingTechMap(data_table, data_addit)"
              class="rounded-xl"
              color="teal"
              outlined
          >
            Отправить повторно
          </v-btn>
        </v-slide-x-transition>
      </v-card-actions>
    </v-card>
  </v-card>
</template>

<script>
import {mapActions, mapState, mapMutations} from "vuex";
import _ from "lodash";
import EditDialogFieldDataTable from "../EditDialogs/EditDialogFieldDataTable";
import DialogInputElements from "../EditDialogs/DialogInputElements";
import CardAdditData from "../Cards/CardAdditData"
import CardTableTechMap from "./CardTableTechMap.vue";
import CardAdditDataForElective from "../Cards/CardAdditDataForElective.vue"
import TechnologicalMapPDF from "../../../../makepdfs/study/technological_map_pdf";
import DialogEditEduHours from "../EditDialogs/DialogEditEduHours.vue";
import CardParticipants from "./CardParticipants.vue";

export default {
  name: "CardFillingTechnologicalMap",
  components: {
    CardParticipants,
    DialogEditEduHours,
    CardTableTechMap,
    EditDialogFieldDataTable,
    DialogInputElements,
    CardAdditData,
    CardAdditDataForElective
  },
  data: () => ({
    data_addit: {
      educational_programs_ids: [],
      discipline_id: '',
      chair_ids: [],
      curriculum_id: '',
      semesters: [],
      study_year_id: '',
      form_education: '',
      type_course: 0,
      level_educations: [],
      cofounders: []
    },
    full_name_author: '',
    visible_tech_map: false,
    data_table: [],
    original_table: [],
    edit_mode: false,
    visible_sending_tech_map: false,
    areas_training: ['Зачет', 'Экзамен', 'Зачет с оценкой', 'Курсовая работа', 'Защита ВКР'],
    alternative_view: false,
    componentKey: 0,
    keyDialog: 0,
    list_orig_loads: [
      'types_lecture',
      'types_laboratory_work',
      'types_practical_training',
      'types_students_independent_work'
    ],
    check_type_course: false,
    dialog_vis_edit_hours: false,
    edit_semester_hours: [],
    tm_download: false
  }),
  mounted() {
    this.getListEducationalPrograms();
    this.getCurrentCourse().then(() => this.initializeDataTable());
  },
  watch: {},
  computed: {
    ...mapState({
      current_course: state => state.studyEstimationEuk.current_course,
      technical_map: state => state.studyEstEukTechMap.technical_map,
      loading_update_course: state => state.studyEstimationEuk.loading_update_course,
      new_data_modules_current_course: state => state.studyEstimationEuk.new_data_modules_current_course,
      loading_get_tech_map: state => state.studyEstimationEuk.loading_get_tech_map,
      list_curriculum_lines: state => state.studyEstEukTechMapAdditData.list_curriculum_lines,
      list_educational_programs: state => state.studyEstEukTechMapAdditData.list_educational_programs,
    }),
  },
  methods: {
    ...mapActions({
      postTechnicalMap: 'studyEstEukTechMap/postTechnicalMap',
      getAsyncCurrentCourse: 'studyEstimationEuk/getAsyncCurrentCourse',
      updateTechnicalMap: 'studyEstEukTechMap/updateTechnicalMap',
      getCurrentCourse: 'studyEstimationEuk/getCurrentCourse',
      getAdditData: 'studyEstEukTechMapAdditData/getAdditData',
      getDisciplines: 'studyEstEukTechMapAdditData/getDisciplines',
      getSemesters: 'studyEstEukTechMapAdditData/getSemesters',
      getStudyYears: 'studyEstEukTechMapAdditData/getStudyYears',
      getHoursPlan: 'studyEstEukTechMapAdditData/getHoursPlan',
      getListEducationalPrograms: 'studyEstEukTechMapAdditData/getListEducationalPrograms',
    }),
    ...mapMutations({
      setCurriculumLinesTechMap: 'studyEstEukTechMapAdditData/setCurriculumLinesTechMap',
      setFormatControl: 'studyEstEukTechMapAdditData/setFormatControl',
      addNewFormatControl: 'studyEstEukTechMapAdditData/addNewFormatControl',
      deleteNewFormatControl: 'studyEstEukTechMapAdditData/deleteNewFormatControl'
    }),
    async initializeDataTable() {
      if (Object.keys(this.current_course).length > 0) {
        this.check_type_course = true
        this.edit_mode = true
        this.full_name_author = this.current_course?.full_name_author

        this.original_table = _.cloneDeep(this.current_course?.course_content?.data_tech_map)
        this.alternative_view = this.current_course?.course_content?.parameters_tech_map?.alternative_view
      } else {
        this.check_type_course = false
        this.edit_mode = false
        this.tm_download = true

        this.full_name_author = this.technical_map.full_name
        this.data_addit.type_course = this.technical_map.type_course
        this.data_addit.level_educations = this.technical_map.level_educations
        this.data_addit.chair_ids = this.technical_map.list_chairs
        this.data_addit.study_year_id = this.technical_map.study_year.id
        this.data_addit.form_education = this.technical_map.form_education
        this.data_addit.cofounders = this.technical_map.cofounders
        await this.setEducationalProgramsCurrTechMap()
        await this.getStudyYears()
        await this.setCurriculumAndDisciplineCurrTechMap()
        await this.setSemestersCurrTechMap()
        this.setCurriculumLinesTechMap(_.cloneDeep(this.technical_map?.data_training?.data_semesters))

        this.data_table = _.cloneDeep(this.technical_map?.data_technological_map?.data_table)
        this.alternative_view = this.technical_map?.data_technological_map?.alternative_view
        this.displayTechMap()
      }
    },
    setEducationalProgramsCurrTechMap() {
      this.data_addit.educational_programs_ids = this.technical_map.list_educational_programms

      this.data_addit.study_year_id = this.technical_map.curriculum.study_year_id

      let params = {
        educational_programs_ids: this.data_addit.educational_programs_ids,
        study_year_id: this.data_addit.study_year_id
      }

      this.getAdditData(params)
    },
    setCurriculumAndDisciplineCurrTechMap() {
      this.data_addit.curriculum_id = this.technical_map.curriculum.id
      this.data_addit.discipline_id = this.technical_map.list_disciplines[0]

      this.getDisciplines({curriculum_id: this.technical_map.curriculum.id})
    },
    setSemestersCurrTechMap() {
      this.getSemesters(
          {
            curriculum_id: this.data_addit.curriculum_id,
            discipline_id: this.data_addit.discipline_id,
          }
      )
      this.data_addit.semesters = this.technical_map?.data_training?.semesters
    },
    sendingTechMap(data_table, data_addit) {
      let data_tech_map = {
        course_id: this.current_course.course_id,
        course_full_name: this.current_course.course_full_name,
        data_technological_map: {
          data_table: data_table,
          alternative_view: this.alternative_view
        },
        data_addit: data_addit,
        data_training: this.list_curriculum_lines
      }

      this.postTechnicalMap(data_tech_map)

      this.edit_mode = false
      this.visible_sending_tech_map = false
      this.tm_download = true
    },
    updatingTechMap(data_table, data_addit) {
      let data_tech_map = {
        technical_map_id: this.technical_map.id,
        data_technological_map: {
          data_table: data_table,
          alternative_view: this.alternative_view
        },
        data_addit: data_addit,
        data_training: this.list_curriculum_lines
      }
      this.updateTechnicalMap(data_tech_map)
      this.edit_mode = false
    },
    asyncCurrentTechMap(props) {
      this.getAsyncCurrentCourse(props)
          .then(() => {
            let content_semester_index = _.findIndex(this.data_table, (item_semester) => {
              return item_semester.semester === props.semester
            })

            this.data_table[content_semester_index].data_tech_map = this.new_data_modules_current_course.data_tech_map
            this.componentKey += 1
          })
    },
    displayTechMap() {
      this.visible_tech_map = true
      this.visible_sending_tech_map = Object.keys(this.technical_map).length <= 0
    },
    setChairIds(props) {
      this.data_addit.chair_ids = props.chair_ids

      // if (this.data_addit.type_course === 2) {
      //
      // }
      this.getStudyYears()
    },
    setStudyYearId(props){
      this.data_addit.study_year_id = props.study_year_id

      if (this.data_addit.type_course === 2) {
        this.getDisciplines(
            {
              type_course: this.data_addit.type_course,
              level_educations: this.data_addit.level_educations,
              study_year_id: this.data_addit.study_year_id
            }
        )
      } else {
        let params = {
          educational_programs_ids: this.data_addit.educational_programs_ids,
          study_year_id: this.data_addit.study_year_id
        }

        this.getAdditData(params)
      }
    },
    setEducationalProgramsIds(props) {
      this.data_addit.educational_programs_ids = props.educational_programs_ids
      this.data_addit.curriculum_id = ''
      this.data_addit.discipline_id = ''
      this.data_addit.semesters = []
      this.data_addit.study_year_id = ''
    },
    setCurriculumId(props) {
      this.data_addit.curriculum_id = props.curriculum_id
      this.data_addit.discipline_id = ''
      this.data_addit.semesters = []

      this.getDisciplines(
          {
            type_course: this.data_addit.type_course,
            curriculum_id: props.curriculum_id
          }
      )
    },
    setDisciplineId(props) {
      this.data_addit.discipline_id = props.discipline_id
      this.data_addit.semesters = []

      this.getSemesters(
          {
            type_course: this.data_addit.type_course,
            curriculum_id: this.data_addit.curriculum_id,
            discipline_id: this.data_addit.discipline_id,
            study_year_id: this.data_addit.study_year_id
          }
      )
      this.keyDialog += 1
    },
    setFormEducation(props) {
      this.data_addit.form_education = props.form_education
    },
    async setSemesters(props) {
      this.data_addit.semesters = props.semesters
      this.data_table = []

      await this.getHoursPlan(
          {
            type_course: this.data_addit.type_course,
            curriculum_id: this.data_addit.curriculum_id,
            discipline_id: this.data_addit.discipline_id,
            semesters: this.data_addit.semesters,
            study_year_id: this.data_addit.study_year_id
          }
      )

      this.setDataForSemester()
    },
    setDataForSemester(){
      this.list_curriculum_lines.forEach((semester, index) => {
        this.data_table.push(
            {
              semester: semester.semester_name,
              format_controls: semester.format_controls,
              data_tech_map: this.adaptDataTechMap(semester.hours, semester.format_controls)
            }
        )

        this.setFormatControl({values: semester.format_controls, index: index})
      })

      this.displayTechMap()
    },
    setFormatControlForSemester(name_format_control, index_semester, semester, index_format_control) {
      let semester_original_index = _.findIndex(this.data_table, (item_semester) => {
        return item_semester.semester === semester.semester_name
      })

      this.data_table[semester_original_index].format_controls[index_format_control] = name_format_control

      let len_format_controls = this.data_table[semester_original_index].format_controls.length
      let len_data_table = this.data_table[semester_original_index].data_tech_map.length

      this.data_table[semester_original_index].data_tech_map[(len_data_table - len_format_controls) + (index_format_control)].name = name_format_control

      if (Object.keys(this.technical_map).length > 0){
        this.setFormatControl({values: _.cloneDeep(this.data_table[semester_original_index].format_controls), index: index_semester})
      } else {
        this.setFormatControl({values: this.data_table[semester_original_index].format_controls, index: index_semester})
      }
    },
    adaptDataTechMap(hours, format_controls) {
      let data_tech_map = _.cloneDeep(this.original_table)

      let list_missing_loads = []

      hours.forEach((hour) => {
        switch (hour.load) {
          case 'Лекционные занятия':
            list_missing_loads.push('types_lecture')
            break
          case 'Лабораторные занятия':
            list_missing_loads.push('types_laboratory_work')
            break
          case 'Практические занятия':
            list_missing_loads.push('types_practical_training')
            break
          case 'Самостоятельная работа':
            list_missing_loads.push('types_students_independent_work')
            break
        }
      })

      list_missing_loads = _.difference(this.list_orig_loads, list_missing_loads);

      data_tech_map.forEach((item_tech_map) => {
        if (item_tech_map.hasOwnProperty("items")) {
          item_tech_map.items.forEach((item_children_tech_map) => {
            list_missing_loads.forEach((missing_load) => {
              item_children_tech_map[missing_load].push('Не предусмотрено')
            })
          })
        } else {
          list_missing_loads.forEach((missing_load) => {
            item_tech_map[missing_load].push('Не предусмотрено')
          })
        }
      })

      format_controls.forEach((fc) => {
        data_tech_map.push({name: fc, types_final_control: []})
      })

      return data_tech_map
    },
    choiceTypeCourse(type_course) {
      this.data_addit.type_course = type_course

      this.check_type_course = false
    },
    setLevelEducation(props) {
      this.data_addit.level_educations = props.level_educations
    },
    closeDialogEditEduHours() {
      this.dialog_vis_edit_hours = false
    },
    openDialogEditEduHours(semester_hours) {
      this.dialog_vis_edit_hours = true

      this.edit_semester_hours = semester_hours
    },
    setHoursInTypeWork(props, semester_hours) {
      _.find(semester_hours, (hour) => {
        return hour.load === props.hour_load
      }).value = props.hours_value
    },
    addFormControl(semester) {
      let semester_index = _.findIndex(this.data_table, (item_semester) => {
        return item_semester.semester === semester.semester_name
      })

      this.data_table[semester_index].format_controls.push('')
      this.data_table[semester_index].data_tech_map.push({name: '', types_final_control: []})

      if (Object.keys(this.technical_map).length > 0){
        this.addNewFormatControl({value: '', index: semester_index})
      }
    },
    deleteFormControl(semester, index_format_control) {
      let semester_index = _.findIndex(this.data_table, (item_semester) => {
        return item_semester.semester === semester.semester_name
      })

      let len_format_controls = this.data_table[semester_index].format_controls.length
      let len_data_table = this.data_table[semester_index].data_tech_map.length

      this.data_table[semester_index].format_controls.splice(index_format_control, 1)
      this.data_table[semester_index].data_tech_map.splice((len_data_table - len_format_controls) + (index_format_control), 1)

      if (Object.keys(this.technical_map).length > 0){
        this.deleteNewFormatControl({index: semester_index, index_format_control: index_format_control})
      }
    },
    inputCofounder(props){
      this.data_addit.cofounders[props.index] = props.name_cofounder
    },
    addVoidCofounder(){
      this.data_addit.cofounders.push('')
    },
    deleteNameCofounder(props){
      this.data_addit.cofounders.splice(props.index, 1)
    },
    createFileTM() {
      TechnologicalMapPDF.createPDF(this.technical_map)
    }
  }
}
</script>

<style scoped>
.position-relative {
  position: relative;
}

.edit-btn {
  position: absolute;
  top: 0;
  right: 0;
}

.update-btn {
  position: absolute;
  top: 0;
  left: 0;
}

.edit-mode-text {
  position: absolute;
  top: 17px;
  right: 55px;
}

.edit-btn-l {
  position: absolute;
  top: 0;
  left: 0;
}

.edit-mode-text-l {
  position: absolute;
  top: 17px;
  left: 55px;
}
</style>